function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Dialog, DialogBackdrop } from 'reakit';
import { buildClassNames } from '../../../modules/css-helpers';
import { colors } from '../../../theme';
import { OwnUpButton } from '../../buttons';
import { createOwnUpComponent } from '../../components';
import { OwnUpIcon } from '../../images/icons';
import { OwnUpHeader } from '../../typography/header';
import { OwnUpSectionBreak } from '../section-break';
import { OwnUpModalBackdropStyle, OwnUpModalBodyStyle, OwnUpModalFooterStyle, OwnUpModalHeaderStyle, OwnUpModalStyle, OwnUpModalXButtonStyle } from './style';
/**
 * Own Up Modal component properties.
 */

var OwnUpModalImpl = createOwnUpComponent(Dialog, OwnUpModalStyle);
var OwnUpModalBackdrop = createOwnUpComponent(DialogBackdrop, OwnUpModalBackdropStyle);
var OwnUpModalHeaderWrapper = createOwnUpComponent('div', OwnUpModalHeaderStyle);
var OwnUpModalBodyWrapper = createOwnUpComponent('div', OwnUpModalBodyStyle);
var OwnUpModalFooterWrapper = createOwnUpComponent('div', OwnUpModalFooterStyle);
var OwnUpModalXButton = createOwnUpComponent('button', OwnUpModalXButtonStyle);
/**
 * An Own Up branded modal.
 */

export var OwnUpModal = function OwnUpModal(_ref) {
  var controller = _ref.controller,
      _ref$cancellable = _ref.cancellable,
      cancellable = _ref$cancellable === void 0 ? false : _ref$cancellable,
      _ref$submittable = _ref.submittable,
      submittable = _ref$submittable === void 0 ? true : _ref$submittable,
      _ref$cancelOnly = _ref.cancelOnly,
      cancelOnly = _ref$cancelOnly === void 0 ? false : _ref$cancelOnly,
      _ref$preventScroll = _ref.preventScroll,
      preventScroll = _ref$preventScroll === void 0 ? true : _ref$preventScroll,
      _ref$cancelText = _ref.cancelText,
      cancelText = _ref$cancelText === void 0 ? 'Cancel' : _ref$cancelText,
      _ref$submitText = _ref.submitText,
      submitText = _ref$submitText === void 0 ? 'Submit' : _ref$submitText,
      _ref$submitDisabled = _ref.submitDisabled,
      submitDisabled = _ref$submitDisabled === void 0 ? false : _ref$submitDisabled,
      children = _ref.children,
      header = _ref.header,
      onCancel = _ref.onCancel,
      onSubmit = _ref.onSubmit,
      className = _ref.className,
      backdropClassName = _ref.backdropClassName,
      headerClassName = _ref.headerClassName,
      footerClassName = _ref.footerClassName,
      variant = _ref.variant,
      sectionBreakStyle = _ref.sectionBreakStyle,
      containerStyle = _ref.containerStyle,
      finalFocusRef = _ref.finalFocusRef,
      props = _objectWithoutProperties(_ref, ["controller", "cancellable", "submittable", "cancelOnly", "preventScroll", "cancelText", "submitText", "submitDisabled", "children", "header", "onCancel", "onSubmit", "className", "backdropClassName", "headerClassName", "footerClassName", "variant", "sectionBreakStyle", "containerStyle", "finalFocusRef"]);

  // State is used to determine if a submit/cancel Promise is running.
  //   The modal cannot re-trigger a cancel/submit if a Promise is running.
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      processing = _useState2[0],
      setProcessing = _useState2[1];

  var builtHeaderClassName = useMemo(function () {
    return buildClassNames('ou-modal__header', headerClassName);
  }, [headerClassName]); // Store a ref that will be used for the Header HTML element.
  // This will be used later to force the modal to scroll to the top
  //  when the modal pops in.

  var headerRef = useRef(); // Memoize the header component. This component will
  //   either be the pure component or if it is a string, will
  //   wrap the string in a modal-variant OwnUpHeader.
  //
  // If no header is provided, the div will still be rendered
  //   to ensure whitespace is consistent.

  var headerComponent = useMemo(function () {
    if (typeof header === 'string') {
      return /*#__PURE__*/React.createElement(OwnUpModalHeaderWrapper, {
        ref: headerRef,
        className: builtHeaderClassName
      }, /*#__PURE__*/React.createElement(OwnUpHeader, {
        variant: "modal"
      }, header));
    }

    return /*#__PURE__*/React.createElement(OwnUpModalHeaderWrapper, {
      ref: headerRef,
      className: builtHeaderClassName
    }, header);
  }, [builtHeaderClassName, header]); // Memoize the section break component. This will only exist if
  //   both the header and body are present.

  var breakComponent = useMemo(function () {
    if (header && children) {
      return /*#__PURE__*/React.createElement(OwnUpSectionBreak, {
        variant: "modal",
        style: sectionBreakStyle
      });
    }

    return null;
  }, [children, header, sectionBreakStyle]); // Memoize the cancel action. Will run or await whatever the
  //   onCancel action is then close the dialog.

  var cancelAction = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var closeWindow;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setProcessing(true);
            closeWindow = true;

            if (!onCancel) {
              _context.next = 6;
              break;
            }

            _context.next = 5;
            return Promise.resolve(onCancel());

          case 5:
            closeWindow = _context.sent;

          case 6:
            if (closeWindow) {
              controller.hide();
            }

            setProcessing(false);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [controller, onCancel, setProcessing]); // Memoize the submit action. Will run or await whatever the
  //   onSubmit action is then close the dialog.

  var submitAction = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var closeWindow;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            setProcessing(true);
            closeWindow = true;

            if (!onSubmit) {
              _context2.next = 6;
              break;
            }

            _context2.next = 5;
            return Promise.resolve(onSubmit());

          case 5:
            closeWindow = _context2.sent;

          case 6:
            if (closeWindow) {
              controller.hide();
            }

            setProcessing(false);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [controller, onSubmit, setProcessing]); // Memoize the cancel button component, which will only appear
  //   when the 'cancellable' property is set. Will render with
  //   whatever text appears in 'cancelText', defaulting to 'Cancel'.

  var cancelComponent = useMemo(function () {
    return cancellable && !cancelOnly ? /*#__PURE__*/React.createElement(OwnUpButton, {
      variant: ['lightAlt', 'square'],
      onClick: cancelAction,
      disabled: processing
    }, cancelText || 'Cancel') : null;
  }, [cancellable, cancelOnly, cancelText, cancelAction, processing]); // Memoize the "X" component, which will appear when
  //   the 'cancellable' or 'cancelOnly' property is set.

  var xComponent = useMemo(function () {
    if (cancellable || cancelOnly) {
      return /*#__PURE__*/React.createElement(OwnUpModalXButton, {
        onClick: cancelAction,
        disabled: processing,
        variant: variant
      }, /*#__PURE__*/React.createElement(OwnUpIcon, {
        icon: "CancelX",
        height: '24px',
        color: colors.PRIMARY_ALT,
        strokeWidth: 1
      }));
    }

    return null;
  }, [cancelAction, cancellable, cancelOnly, processing, variant]); // Memoize the submit button component. Will render with whatever
  //   text appears in 'submitText', defaulting to 'Submit'.

  var submitComponent = useMemo(function () {
    return submittable && !cancelOnly ? /*#__PURE__*/React.createElement(OwnUpButton, {
      variant: "square",
      onClick: submitAction,
      disabled: submitDisabled || processing
    }, submitText || 'Submit') : null;
  }, [submittable, cancelOnly, submitText, processing, submitAction, submitDisabled]);
  var builtFooterClassName = useMemo(function () {
    return buildClassNames('ou-modal__footer', footerClassName);
  }, [footerClassName]); // Memoize the body of the component.

  var bodyComponent = useMemo(function () {
    return /*#__PURE__*/React.createElement(OwnUpModalBodyWrapper, null, children);
  }, [children]);
  var footerComponent = useMemo(function () {
    return /*#__PURE__*/React.createElement(OwnUpModalFooterWrapper, {
      className: builtFooterClassName
    }, cancelComponent, submitComponent);
  }, [builtFooterClassName, submitComponent, cancelComponent]);
  var builtBackdropClassName = useMemo(function () {
    return buildClassNames('ou-modal__backdrop', backdropClassName);
  }, [backdropClassName]);
  var builtModalClassName = useMemo(function () {
    return buildClassNames('ou-modal', className);
  }, [className]); // Effect that will force the modal header to scroll into view.
  //   Will be triggered by the modal visibility changing.

  useEffect(function () {
    if (headerRef.current && controller.state.visible) {
      // Ensure the browser supports scroll-snapping
      if (typeof headerRef.current.scrollIntoView === 'function') {
        headerRef.current.scrollIntoView(true);
      }
    }
  }, [controller.state.visible, headerRef]);
  return /*#__PURE__*/React.createElement(OwnUpModalBackdrop, _extends({
    className: builtBackdropClassName
  }, controller.state), /*#__PURE__*/React.createElement(OwnUpModalImpl, _extends({
    className: builtModalClassName
  }, controller.state, {
    variant: variant,
    hideOnClickOutside: cancelOnly,
    preventBodyScroll: preventScroll,
    unstable_finalFocusRef: finalFocusRef
  }, props), headerComponent, breakComponent, bodyComponent, footerComponent, xComponent));
};